/****************************************************
 * Module Name:  customerMasterComponent.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { DataGridPro, GridToolbar } from "@mui/x-data-grid-pro";
import { Box, Avatar, Chip, Tooltip } from "@mui/material";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import renderCellExpand from "../common/dataGridCellExpand";
import PersonIcon from "@mui/icons-material/Person";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import EditCustomerModal from "../master/editCustomerModal";
import Constants from "../../utility/constants";
import CommonSnackbar from "./commonSnackBar";
import EditBrokerModal from "../master/editBrokerModal";
import EditEmployeeModal from "../master/editEmployeeModal";
import CustomerProxy from "../../utility/proxy/manager/customerProxy";
import EmployeeProxy from "../../utility/proxy/manager/employeeProxy";
import BrokerProxy from "../../utility/proxy/manager/brokerProxy";
import Utility from "../../utility/utility";
import NoPermission from "../common/noPermission";
import AddCustomersettingsModalWrapper from "../settings/addCustomersettingsModalWrapper";
import logo from '../../images/pansuriya.jpg'
import { TbSettingsCode } from "react-icons/tb";
import { TbSettingsCancel } from "react-icons/tb";
import PageTitle from "./pageTitle";


export class CustomerMasterComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      customers: [],
      filterMap: {},
      columnNames: [],

      showUserSettingsModal: false,
      userSettingsUserName: "",

      editOperation: false,
      sourceData: {},

      employeeId: "",
      brokerId: "",
      customerId: "",

      showEditCustomerModal: false,
      showCustomerSettingsModal: false,
      showCustomerApiSettingsModal: false,
      errorSnackbar: false,
      loadingButton: false,

      showCustomerLoadSpinner: true,
      showEditBrokerModal: false,
      showEditEmployeeModal: false,
      successSnackbar: false,
      ftpSettingType: false,
      local_Permission: Constants.USER_PERMISSION.filter(
        (iPermission) =>
          iPermission.permissionid === Constants.PERMISSIONS.MASTER_CUSTOMER
      ),
      FTPSettings_Permission: Constants.USER_PERMISSION.filter(
        (iPermission) =>
          iPermission.permissionid === Constants.PERMISSIONS.MASTER_CUSTOMER_FTPSETTING),
      APISettings_Permission: Constants.USER_PERMISSION.filter(
        (iPermission) =>
          iPermission.permissionid === Constants.PERMISSIONS.MASTER_CUSTOMER_APISETTING),
      anchorEl: null,
      openMenuId: null,
      openBrokersMenuId: null,
      anchorEl1: null,
      openMenuId1: null,
      openEmployeesMenuId: null,
    };
  }

  componentDidMount() {
    this.fetchCustomerData(true);
    PageTitle("MASTER_CUSTOMER");
  }

  fetchCustomerData = (bAnimateSpinner) => {
    if (bAnimateSpinner) {
      this.setState({ showCustomerLoadSpinner: true });
    }
    if (
      (Constants.USER_PERMISSION.find(
        (iPermission) =>
          iPermission.permissionid === Constants.PERMISSIONS.MASTER_CUSTOMER || iPermission.permissionid === Constants.PERMISSIONS.CUSTOMER_FTPSETTING_PERMISSION
      ) === undefined) && Constants.loggedInUser.usertype === 'E'
    ) {
      CustomerProxy.GetSingleEmployeesCustomerById(
        Constants.loggedInUser.id,
        (responseData) => {
          if (responseData) {
            const uniqueFilterValues = {
              createdby: Utility.getDistinctOptions(responseData, "createdby"),
              designation: Utility.getDistinctOptions(responseData, "designation"),
              grade: Utility.getDistinctOptions(responseData, "grade"),
              location: Utility.getDistinctOptions(responseData, "location"),
              locationcountry: Utility.getDistinctOptions(responseData, "locationcountry"),
              city: Utility.getDistinctOptions(responseData, "city"),
              state: Utility.getDistinctOptions(responseData, "state"),
              country: Utility.getDistinctOptions(responseData, "country"),
              companyname: Utility.getDistinctOptions(responseData, "companyname"),
              title: Utility.getDistinctOptions(responseData, "title"),
              phonecode: Utility.getDistinctOptions(responseData, "phonecode"),
              pincode: Utility.getDistinctOptions(responseData, "pincode"),
            };
            const filterMap = this.generateFilterMap(Array.isArray(responseData) ? responseData : [responseData]);
            this.setState({
              customers: responseData,
              filterMap: filterMap,
              showCustomerLoadSpinner: false,
            })
            this.prepareColumns(filterMap, uniqueFilterValues);
          } else {
            this.setState({
              errorSnackbar: true,
              showCustomerLoadSpinner: false,
            })
          }
        }
      );
    }
    else if (
      (Constants.USER_PERMISSION.find(
        (iPermission) =>
          iPermission.permissionid === Constants.PERMISSIONS.MASTER_CUSTOMER || iPermission.permissionid === Constants.PERMISSIONS.CUSTOMER_FTPSETTING_PERMISSION
      ) === undefined) && Constants.loggedInUser.usertype === 'C'
    ) {
      CustomerProxy.GetSingleCustomerById(
        Constants.loggedInUser.id,
        (responseData) => {
          if (responseData) {
            const uniqueFilterValues = {
              createdby: Utility.getDistinctOptions(responseData, "createdby"),
              designation: Utility.getDistinctOptions(responseData, "designation"),
              grade: Utility.getDistinctOptions(responseData, "grade"),
              location: Utility.getDistinctOptions(responseData, "location"),
              locationcountry: Utility.getDistinctOptions(responseData, "locationcountry"),
              city: Utility.getDistinctOptions(responseData, "city"),
              state: Utility.getDistinctOptions(responseData, "state"),
              country: Utility.getDistinctOptions(responseData, "country"),
              companyname: Utility.getDistinctOptions(responseData, "companyname"),
              title: Utility.getDistinctOptions(responseData, "title"),
              phonecode: Utility.getDistinctOptions(responseData, "phonecode"),
              pincode: Utility.getDistinctOptions(responseData, "pincode"),
            };
            const filterMap = this.generateFilterMap(Array.isArray(responseData) ? responseData : [responseData]);
            this.setState({
              customers: [responseData],
              filterMap: filterMap,
              showCustomerLoadSpinner: false,
            })
            this.prepareColumns(filterMap, uniqueFilterValues);
          } else {
            this.setState({
              errorSnackbar: true,
              showCustomerLoadSpinner: false,
            })
          }
        }
      );
    } else {
      CustomerProxy.GetAllCustomerDetail((responseData) => {
        if (responseData) {
          const uniqueFilterValues = {
            createdby: Utility.getDistinctOptions(responseData, "createdby"),
            designation: Utility.getDistinctOptions(responseData, "designation"),
            grade: Utility.getDistinctOptions(responseData, "grade"),
            location: Utility.getDistinctOptions(responseData, "location"),
            locationcountry: Utility.getDistinctOptions(responseData, "locationcountry"),
            city: Utility.getDistinctOptions(responseData, "city"),
            state: Utility.getDistinctOptions(responseData, "state"),
            country: Utility.getDistinctOptions(responseData, "country"),
            companyname: Utility.getDistinctOptions(responseData, "companyname"),
            title: Utility.getDistinctOptions(responseData, "title"),
            phonecode: Utility.getDistinctOptions(responseData, "phonecode"),
            pincode: Utility.getDistinctOptions(responseData, "pincode"),
          };
          const filterMap = this.generateFilterMap(Array.isArray(responseData) ? responseData : [responseData]);
          this.setState({
            customers: responseData,
            filterMap: filterMap,
            showCustomerLoadSpinner: false,
          })
          this.prepareColumns(filterMap, uniqueFilterValues);
        } else {
          this.setState({
            errorSnackbar: true,
            showCustomerLoadSpinner: false,
          })
        }
      }
      );
    }
  };

  generateFilterMap = (responseData) => {
    const filterMap = {};

    // Process broker customers
    const brokerCustomers = responseData.flatMap((customer) =>
      customer.brokercustomer.map((broker) => ({
        id: broker.brokerid,
        username: broker.username,
      }))
    );
    filterMap.brokercustomer = [
      ...new Set(
        brokerCustomers.map((broker) => `${broker.id} | ${broker.username}`)
      ),
    ];

    // Process employee customers
    const employeeCustomers = responseData.flatMap((customer) =>
      customer.employecustomer.map((employee) => ({
        id: employee.employeid,
        username: employee.username,
      }))
    );
    filterMap.employecustomer = [
      ...new Set(
        employeeCustomers.map(
          (employee) => `${employee.id} | ${employee.username}`
        )
      ),
    ];

    return filterMap;
  };


  prepareColumns = (filterMap, uniqueFilterValues) => {
    let columnNames = [];
    const columnData = this.initialColumns(uniqueFilterValues);

    columnData.forEach(iCol => {
      if (iCol.field === "employecustomer") {
        iCol.type = "singleSelect";
        iCol.valueOptions = filterMap ? filterMap.employecustomer : [];
        iCol.filterOperators = Utility.customFilters(filterMap, iCol.field, 'employeid', 'username');
      }
      if (iCol.field === "brokercustomer") {
        iCol.type = "singleSelect";
        iCol.valueOptions = filterMap ? filterMap.brokercustomer : [];
        iCol.filterOperators = Utility.customFilters(filterMap, iCol.field, 'customerid', 'username');
      }
      columnNames.push(iCol);
    });
    this.setState({
      columnNames: columnNames
    })
  }

  initialColumns = (combinedFilterValues) => [
    {
      field: "id",
      headerName: "ID",
      headerAlign: "center",
      align: "center",
      minWidth: 50,
    },
    {
      field: "companyname",
      headerName: "COMPANY NAME",
      headerAlign: "center",
      align: "center",
      minWidth: 150,
      flex: 1,
      type: "singleSelect",
      valueOptions: combinedFilterValues ? combinedFilterValues.companyname : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "title",
      headerName: "TITLE",
      headerAlign: "center",
      align: "center",
      width: 60,
      flex: 1,
      type: "singleSelect",
      valueOptions: combinedFilterValues ? combinedFilterValues.title : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "first_name",
      headerName: "FIRST NAME",
      headerAlign: "center",
      align: "center",
      minWidth: 130,
      flex: 1,
      renderCell: renderCellExpand,
    },
    {
      field: "last_name",
      headerName: "LAST NAME",
      headerAlign: "center",
      align: "center",
      minWidth: 130,
      flex: 1,
      renderCell: renderCellExpand,
    },
    {
      field: "phonecode",
      headerName: "PHONE CODE",
      headerAlign: "center",
      align: "center",
      width: 100,
      type: "singleSelect",
      valueOptions: combinedFilterValues ? combinedFilterValues.phonecode : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "phone",
      headerName: "PHONE",
      headerAlign: "center",
      align: "center",
      minWidth: 130,
      flex: 1,
      renderCell: renderCellExpand,
    },
    {
      field: "email",
      headerName: "EMAIL",
      headerAlign: "center",
      align: "center",
      minWidth: 220,
      flex: 1,
      renderCell: renderCellExpand,
    },
    {
      field: "username",
      headerName: "USER",
      headerAlign: "center",
      align: "center",
      minWidth: 130,
      flex: 1,
      renderCell: renderCellExpand,
    },
    {
      field: "country",
      headerName: "COUNTRY",
      headerAlign: "center",
      align: "center",
      width: 100,
      type: "singleSelect",
      valueOptions: combinedFilterValues ? combinedFilterValues.country : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "address",
      headerName: "ADDRESS",
      headerAlign: "center",
      align: "center",
      minWidth: 130,
      flex: 1,
      renderCell: renderCellExpand,
    },
    {
      field: "middle_name",
      headerName: "MIDDLE NAME",
      headerAlign: "center",
      align: "center",
      minWidth: 130,
      flex: 1,
      renderCell: renderCellExpand,
    },
    {
      field: "fax",
      headerName: "FAX",
      headerAlign: "center",
      align: "center",
      minWidth: 130,
      flex: 1,
      renderCell: renderCellExpand,
    },
    {
      field: "address2",
      headerName: "ADDRESS2",
      headerAlign: "center",
      align: "center",
      minWidth: 130,
      flex: 1,
      renderCell: renderCellExpand,
    },
    {
      field: "city",
      headerName: "CITY",
      headerAlign: "center",
      align: "center",
      width: 100,
      type: "singleSelect",
      valueOptions: combinedFilterValues ? combinedFilterValues.city : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "state",
      headerName: "STATE",
      headerAlign: "center",
      align: "center",
      width: 100,
      type: "singleSelect",
      valueOptions: combinedFilterValues ? combinedFilterValues.state : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "pincode",
      headerName: "PIN CODE",
      headerAlign: "center",
      align: "center",
      minWidth: 130,
      flex: 1,
      type: "singleSelect",
      valueOptions: combinedFilterValues ? combinedFilterValues.pincode : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "emergencycontactname",
      headerName: "EMERGENCY CONTACT NAME",
      headerAlign: "center",
      align: "center",
      minWidth: 130,
      flex: 1,
      renderCell: renderCellExpand,
    },
    {
      field: "emergencyphone",
      headerName: "EMERGENCY PHONE",
      headerAlign: "center",
      align: "center",
      minWidth: 130,
      flex: 1,
      renderCell: renderCellExpand,
    },
    {
      field: "emergencyaddress",
      headerName: "EMERGENCY ADDRESS",
      headerAlign: "center",
      align: "center",
      minWidth: 130,
      flex: 1,
      renderCell: renderCellExpand,
    },
    {
      field: "gstinno",
      headerName: "GSTN",
      headerAlign: "center",
      align: "center",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "panno",
      headerName: "PAN",
      headerAlign: "center",
      align: "center",
      minWidth: 140,
      flex: 1,
    },
    {
      field: "created",
      headerName: "CREATED AT",
      minWidth: 180,
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => Utility.ConvertUtcToLocalTime(params.value),
    },
    {
      field: "createdby",
      headerName: "CREATED BY",
      headerAlign: "center",
      align: "center",
      width: 170,
      type: "singleSelect",
      valueOptions: combinedFilterValues ? combinedFilterValues.createdby : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "locationid",
      headerAlign: "center",
      align: "center",
      headerName: "LOCATION ID",
      minWidth: 50,
      flex: 0.5,
      renderCell: renderCellExpand,
    },
    {
      field: "location",
      headerAlign: "center",
      align: "center",
      headerName: "LOCATION",
      width: 100,
      type: "singleSelect",
      valueOptions: combinedFilterValues ? combinedFilterValues.location : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "locationcountry",
      headerName: "LOCATION COUNTRY",
      headerAlign: "center",
      align: "center",
      width: 150,
      type: "singleSelect",
      valueOptions: combinedFilterValues ? combinedFilterValues.locationcountry : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "discount",
      headerName: "DIS",
      headerAlign: "center",
      align: "center",
      width: 50,
    },
    {
      field: "designation",
      headerName: "DESIGNATION",
      headerAlign: "center",
      align: "center",
      minWidth: 100,
      flex: 1,
      type: "singleSelect",
      valueOptions: combinedFilterValues ? combinedFilterValues.designation : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "usertype",
      headerName: "TYPE",
      headerAlign: "center",
      align: "center",
      minWidth: 100,
      flex: 1,
      valueGetter: (params) => Constants.USER_TYPE[params.value],
      renderCell: (params) => Constants.USER_TYPE[params.value],
    },
    {
      field: "grade",
      headerName: "GRADE",
      headerAlign: "center",
      align: "center",
      minWidth: 60,
      type: "singleSelect",
      valueOptions: combinedFilterValues ? combinedFilterValues.grade : [],
      filterOperators: Utility.combinedFilters(),
      flex: 0.5,
    },
    {
      field: "employeeid",
      headerName: "EMPLOYEE ID",
      headerAlign: "center",
      align: "center",
      minWidth: 100,
      flex: 0.5,
      renderCell: renderCellExpand,
    },
    {
      field: "brokercustomer",
      headerName: "ASSIGNED TO BROKER",
      width: 400,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (params.value.length === 0) {
          return null;
        }
        return (
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: "10px",
              rowGap: "10px",
            }}
          >
            {params.value.map((item, index) => (
              <Chip
                key={index}
                avatar={<Avatar sx={{ width: 'auto' }}>{item.brokerid}</Avatar>}
                label={item.username}
                onClick={() => {
                  this.setState({
                    showEditBrokerModal: true,
                    editOperation: false,
                    sourceData: undefined,
                    brokerId: item.brokerid,
                    loadingButton: false,
                    anchorEl: null,
                    openBrokersMenuId: null
                  });
                }}
                disabled={
                  Constants.USER_PERMISSION.find(
                    (iPermission) =>
                      iPermission.permissionid ===
                      Constants.PERMISSIONS.MASTER_BROKER &&
                      iPermission.type === "UPDATE"
                  ) === undefined
                }
                sx={{
                  margin: 0,
                  maxWidth: "200px",
                  whiteSpace: "nowrap",
                }}
              />
            ))}
          </Box>
        );
      },
      valueFormatter: (params) => {
        if (!params.value || params.value.length === 0) return "";
        return params.value
          .map((item) => `${item.brokerid} | ${item.username}`)
          .join(",\n");
      },
      sortComparator: (v1, v2) => Utility.sortOperatorFn(v1, v2, "username")
    },
    {
      field: "employecustomer",
      headerName: "ASSIGNED TO EMPLOYEE",
      minWidth: 250,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (params.value.length === 0) {
          return null;
        }
        return (
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: "10px",
              rowGap: "10px",
            }}
          >
            {params.value.map((item, index) => (
              <Chip
                key={index}
                avatar={<Avatar sx={{ width: 'auto' }}>{item.employeid}</Avatar>}
                label={item.username}
                onClick={() => {
                  this.setState({
                    showEditEmployeeModal: true,
                    editOperation: false,
                    sourceData: undefined,
                    employeeId: item.employeid,
                    loadingButton: false,
                    anchorEl1: null,
                    openEmployeesMenuId: false
                  });
                }}
                disabled={
                  Constants.USER_PERMISSION.find(
                    (iPermission) =>
                      iPermission.permissionid ===
                      Constants.PERMISSIONS.MASTER_EMPLOYEE &&
                      iPermission.type === "UPDATE"
                  ) === undefined
                }
                sx={{
                  margin: 0,
                  maxWidth: "200px",
                  whiteSpace: "nowrap",
                }}
              />
            ))}
          </Box>
        );
      },
      valueFormatter: (params) => {
        if (!params.value || params.value.length === 0) return "";
        return params.value
          .map((item) => `${item.employeid} | ${item.username}`)
          .join(",\n");
      },
      sortComparator: (v1, v2) => Utility.sortOperatorFn(v1, v2, "username")
    },
    {
      field: "deleted",
      headerName: "DELETED",
      minWidth: 70,
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        return params.value === false ? (
          <Tooltip title="Active">
            <Box>
              <PersonIcon color="success" />
            </Box>
          </Tooltip>
        ) : (
          <Tooltip title="Inactive">

            <Box>
              <PersonOffIcon color="error" />
            </Box>
          </Tooltip>
        );
      },
    },
    {
      field: "disabled",
      headerName: "DISABLED",
      minWidth: 70,
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        return params.value === false ? (
          <Tooltip title="Enable">
            <Box>
              <PersonIcon color="success" />
            </Box>
          </Tooltip>
        ) : (
          <Tooltip title="Disable">

            <Box>
              <PersonOutlineOutlinedIcon color="error" />
            </Box>
          </Tooltip>
        );
      },
    },
    {
      field: "ftpsetting",
      headerName: "FTP SETTINGS",
      headerAlign: "center",
      align: "center",
      minWidth: 90,
      flex: 0.5,
      type: "boolean",
      renderCell: (params) => {
        return params.value === false ? (
          <Tooltip title="Inactive">
            <Box
              style={{ textAlign: "center", cursor: "pointer" }}
              onClick={() => {
                this.setState({
                  showCustomerSettingsModal: true,
                  customerId: params.row.id,
                })
              }
              }>
              <ManageAccountsOutlinedIcon color="warning" />
            </Box>
          </Tooltip>
        ) : (
          <Tooltip title="Active">
            <Box
              style={{ textAlign: "center", cursor: "pointer" }}
              onClick={() => {
                this.setState({
                  showCustomerSettingsModal: true,
                  customerId: params.row.id,
                })
              }
              }>
              <ManageAccountsIcon color="success" />
            </Box>
          </Tooltip>
        );
      },
    },
    {
      field: "apisetting",
      headerName: "API SETTINGS",
      headerAlign: "center",
      align: "center",
      minWidth: 90,
      flex: 0.5,
      type: "boolean",
      renderCell: (params) => {
        return params.value === false ? (
          <Tooltip title="Inactive">
            <Box
              style={{ textAlign: "center", cursor: "pointer" }}
              onClick={() => {
                this.setState({
                  showCustomerApiSettingsModal: true,
                  customerId: params.row.id,
                })
              }
              }>
              <TbSettingsCancel style={{ color: "#ed6c02" }} size={25} />
            </Box>
          </Tooltip>
        ) : (
          <Tooltip title="Active">
            <Box
              style={{ textAlign: "center", cursor: "pointer" }}
              onClick={() => {
                this.setState({
                  showCustomerApiSettingsModal: true,
                  customerId: params.row.id,
                })
              }
              }>
              <TbSettingsCode style={{ color: "#2e7d32" }} size={25} />
            </Box>
          </Tooltip>
        );
      },
    },
    {
      field: "edit",
      headerName: "EDIT",
      minWidth: 50,
      flex: 0.5,
      headerAlign: "center",
      align: "center",
      sortable: false,
      export: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <Box
            style={{ textAlign: "center", cursor: this.state.local_Permission.length > 1 ? "pointer" : "not-allowed" }}
            onClick={this.state.local_Permission.length > 1 ? () => {
              this.setState({
                showEditCustomerModal: true,
                editOperation: true,
                sourceData: params.row,
                loadingButton: false,
              });
            } : null}
          >
            <BorderColorIcon color={this.state.local_Permission.length > 1 ? "primary" : "disabled"} />

          </Box>
        );
      },
    },
  ];

  handleBrokerMenuClick = (event, id) => {
    this.setState({
      anchorEl: event.currentTarget,
      openBrokersMenuId: id,
    });
  };

  handleBrokerMenuClose = () => {
    this.setState({
      anchorEl: null,
      openBrokersMenuId: null,
    });
  };

  handleEmployeeMenuClick = (event, id) => {
    this.setState({
      anchorEl1: event.currentTarget,
      openEmployeesMenuId: id,
    });
  };

  handleEmployeeMenuClose = () => {
    this.setState({
      anchorEl1: null,
      openEmployeesMenuId: null,
    });
  };

  hideEditCustomerModal = () => {
    this.setState({
      showEditCustomerModal: false,
    });
  };

  handleValidation = (userData) => {
    //TODO do validation if needed here
    return true;
  };

  hideAddUserModal = () => {
    this.setState({
      showEditBrokerModal: false,
      showEditEmployeeModal: false,
    });
  };

  updateBroker = (brokerId, userData) => {
    this.setState({ loadingButton: true });
    //Update existing User, and once user is updated on call refresh the list of current users
    BrokerProxy.UpdateBroker(brokerId, userData, (response) => {
      if (response) {
        this.hideAddUserModal();
        this.setState({ loadingButton: false });
      } else {
        this.setState({ errorSnackbar: true });
        this.setState({ loadingButton: false });
      }
    });
  };

  updateEmployee = (employeeId, userData) => {
    this.setState({ loadingButton: true });
    //Update existing User, and once user is updated on call refresh the list of current users
    EmployeeProxy.UpdateEmployee(employeeId, userData, (response) => {
      if (response) {
        this.hideAddUserModal();
        this.setState({ loadingButton: false });
      } else {
        this.setState({ errorSnackbar: true });
        this.setState({ loadingButton: false });
      }
    });
  };

  editCustomer = (customerId, customerData) => {
    let customerid = customerId;
    this.setState({ loadingButton: true });
    //Update existing Broker, and once user is updated on call refresh the list of current brokers
    CustomerProxy.UpdateCustomer(customerid, customerData, (response) => {
      if (response) {
        this.hideEditCustomerModal();
        this.fetchCustomerData(true);
        this.setState({ loadingButton: false });
      } else {
        this.setState({ errorSnackbar: true });
        this.setState({ loadingButton: false });
      }
    });
  };

  render() {
    let allowed = Utility.isReadAllowed(this.state.local_Permission) || (Constants.USER_PERMISSION.find(
      (iPermission) =>
        iPermission.permissionid ===
        Constants.PERMISSIONS.MASTER_CUSTOMER
    ) === undefined);
    let allowedFTP = Utility.isReadAllowed(this.state.FTPSettings_Permission);
    if ((!allowed && Constants.loggedInUser.usertype !== 'C') && !allowedFTP) {
      return <NoPermission />
    }
    const rows = this.state.customers;
    const columns =
      this.state.columnNames.filter(col =>
        (col.field === "edit")
          ? (Utility.isUpdateAllowed(this.state.local_Permission) && this.props.editButton)
          : (col.field === "ftpsetting")
            ? (Utility.isUpdateAllowed(this.state.FTPSettings_Permission) && Utility.isAddAllowed(this.state.FTPSettings_Permission))
            : (col.field === "apisetting")
              ? (Utility.isUpdateAllowed(this.state.APISettings_Permission) && Utility.isAddAllowed(this.state.APISettings_Permission))
              : true
      );

    return (
      <Box>
        {this.state.showCustomerSettingsModal ? (
          <AddCustomersettingsModalWrapper
            logo={logo}
            isFTPModal={true}
            Show={true}
            loadData={true}
            customerId={this.state.customerId}
            handleClose={() => {
              this.setState({
                showCustomerSettingsModal: false,
              })
            }
            }
            handleSave={() => {
              this.setState({
                successSnackbar: true,
                ftpSettingType: true,
              })
              this.fetchCustomerData(true);
            }
            }
          />
        ) : <Box />}
        {this.state.showCustomerApiSettingsModal ? (
          <AddCustomersettingsModalWrapper
            logo={logo}
            isFTPModal={false}
            Show={true}
            loadData={true}
            customerId={this.state.customerId}
            handleClose={() => {
              this.setState({
                showCustomerApiSettingsModal: false,
              })
            }
            }
            handleSave={() => {
              this.setState({
                successSnackbar: true,
                ftpSettingType: false,
              })
              this.fetchCustomerData(true);
            }
            }
          />
        ) : <Box />}
        {this.state.successSnackbar ? (
          <CommonSnackbar
            show={this.state.successSnackbar}
            message={this.state.ftpSettingType ? `FTP settings updated successfully` : `API settings added successfully`}
            variant={"success"}
            autoHide={true}
            title={"success"}
            handleClose={() => this.setState({ successSnackbar: false })}
          />
        ) : null}
        <CommonSnackbar
          show={this.state.errorSnackbar}
          message={<Box>{Constants.APiFailErrorMessage}</Box>}
          variant={"error"}
          autoHide={Constants.SnackBarCloseTimer}
          handleClose={() => this.setState({ errorSnackbar: false })}
          title="Failed"
        />
        {this.state.showEditCustomerModal ? (
          <EditCustomerModal
            Show={true}
            handleClose={this.hideEditCustomerModal}
            handleSave={this.editCustomer}
            handleValidation={this.handleValidation}
            editOperation={this.state.editOperation}
            sourceData={this.state.sourceData}
            loading={this.state.loadingButton}
            saveButton={true}
          />
        ) : (
          <Box />
        )}
        {this.state.showEditBrokerModal ? (
          <EditBrokerModal
            Show={true}
            handleClose={this.hideAddUserModal}
            handleSave={this.updateBroker}
            handleValidation={this.handleValidation}
            editOperation={this.state.editOperation}
            sourceData={this.state.sourceData}
            userId={this.state.brokerId}
            loading={this.state.loadingButton}
            saveButton={this.props.editButton}
          />
        ) : (
          <Box />
        )}
        {this.state.showEditEmployeeModal ? (
          <EditEmployeeModal
            Show={true}
            handleClose={this.hideAddUserModal}
            handleSave={this.updateEmployee}
            handleValidation={this.handleValidation}
            editOperation={this.state.editOperation}
            sourceData={this.state.sourceData}
            userId={this.state.employeeId}
            loading={this.state.loadingButton}
            saveButton={this.props.editButton}
          />
        ) : (
          <Box />
        )}

        <Box px={1}>
          <Box
            sx={{
              backgroundColor: '#fff',
              color: '#000',
              width: "100%",
              position: "relative",
              "& .MuiTablePagination-selectLabel": {
                marginTop: "15px",
              },
              "& .MuiTablePagination-displayedRows": {
                marginTop: "15px",
              },
              "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                fontWeight: Constants.defaultFontWeight,
              },
              "& .css-cc8tf1": {
                fontWeight: Constants.defaultFontWeight,
              },
              height: this.props.editButton ? "85vh" : "60vh",
            }}
          >
            <DataGridPro
              disableRowSelectionOnClick={true}
              slots={{ toolbar: GridToolbar }}
              rows={rows}
              columns={columns}
              density="compact"
              getRowId={(row) => row.id}
              loading={this.state.showCustomerLoadSpinner}
              getRowHeight={() => "auto"}
              sx={{
                '& .MuiDataGrid-columnHeader': {
                  color: '#fff',
                  backgroundColor: 'grey',
                },
                "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                  py: "4px",
                },
                "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                  py: "12px",
                },
                "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                  py: "18px",
                },
                fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight
              }}
              initialState={{
                columns: {
                  columnVisibilityModel: {
                    // Hide columns status and traderName, the other columns will remain visible
                    id: false,
                    locationid: false,
                    usertype: false,
                    created: false,
                    createdby: false,
                    location: false,
                    locationcountry: false,
                  },
                },
                pinnedColumns: { right: ['edit'] },
                pagination: {
                  paginationModel: Constants.pageSize,
                },
              }}
              pageSizeOptions={Constants.pageSizeOptions}
              pagination
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
            />
            <Box style={{ position: "absolute", top: 5, right: "270px" }}>
              {this.state.showCustomerLoadSpinner ? (
                <CircularProgress size="1rem" />
              ) : (
                <Tooltip title="Reload List">
                  <RefreshOutlinedIcon
                    color="primary"
                    fontSize="medium"
                    onClick={() => this.fetchCustomerData(true)}
                    sx={{ cursor: "pointer" }}
                  />
                </Tooltip>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    );
  }
}

export default CustomerMasterComponent;
